import * as util from "./util.js";
import * as cconst from "./const.js";

// The original AMD module returned the function itself, so export it as default
// and let importers bind it directly (`import report from "./report.js"`).
export default function report(...args: unknown[]): void {
  let s = "";

  for (var i = 0; i < arguments.length; i++) {
    if (i > 0) s += " ";
    s += arguments[i];
  }

  const lines = s.split("\n");

  for (var i = 0; i < lines.length; i++) {
    _appstate.report(lines[i]);
  }
}
